import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import TextInput from "components/form/TextInput";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (code: string) => Promise<void>;
  message?: string;
};

export default function OtpConfirmationModal({
  isOpen,
  onClose,
  onSubmit,
  message = "Enter the six-digit code from your Authenticator app. Your transaction will submit automatically when the code is complete.",
}: Props) {
  const [code, setCode] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) inputRef.current?.focus();
    if (!isOpen) setCode("");
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      initialFocusRef={inputRef}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>OTP Code</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>
            {message}
          </Text>
          <TextInput
            id="transaction-otp"
            inputRef={inputRef}
            label="Code"
            aria-label="Code"
            name="otp_code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(event) => {
              const nextCode = event.target.value.replace(/\D/g, "").slice(0, 6);
              setCode(nextCode);
              if (nextCode.length === 6) {
                setCode("");
                void onSubmit(nextCode);
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
